import { prettyId } from '../../../utils/data.utils';

export function reduceForSelect(
  array: any,
  getSelectItem = getSelectItemDefault
) {
  if (!Array.isArray(array) || !array.length) {
    return [];
  }

  return array.reduce((accum, value) => {
    const selectItem = getSelectItem(value);

    if (selectItem == null) {
      return accum;
    }

    return [...accum, selectItem];
  }, []);
}

function getSelectItemDefault(listItem: any) {
  const { id, name } = listItem;
  if (!listItem || !id || !name) {
    return undefined;
  }

  return { label: name, value: id, meta: { ...listItem } };
}

export function getSelectItemAgency(agency: any) {
  const label = getAgencyLabel(agency);

  return { label, value: agency.id, meta: { ...agency } };
}

export function reduceForAccountData(array: any) {
  if (array && array.length) {
    return array.reduce((accum: any, value: any) => {
      const { accountId, accountName, roleId, accountType, teams } = value;
      if (!value) {
        return accum;
      }
      return [
        ...accum,
        {
          id: prettyId(),
          account: accountId,
          accountName,
          role: roleId,
          accountType,
          teams,
        },
      ];
    }, []);
  }
}

export function reduceForAgenciesData(array: any) {
  if (array && array.length) {
    return array.reduce((accum: any, value: any) => {
      const { name, id } = value;
      if (!value) {
        return accum;
      }
      return [...accum, { label: `${name}`, value: id }];
    }, []);
  }
}

export function mapAgencyPersonas(array: any) {
  if (array && array.length) {
    return array.map((post: any) => {
      return post.account;
    });
  }
}

export function reduceForAgencies(array: any) {
  if (array && array.length) {
    return array.reduce((accum: any, value: any) => {
      const {
        id,
        contactFirstName,
        contactLastName,
        contactEmail,
        contactPhone,
      } = value;

      if (!value) {
        return accum;
      }

      const label = getAgencyLabel(value);

      return [
        ...accum,
        {
          label,
          value: id,
          agentFirstName: contactFirstName,
          agentLastName: contactLastName,
          agentEmail: contactEmail,
          agentPhoneNumber: contactPhone,
        },
      ];
    }, []);
  }

  return [];
}

export function reduceForAgency(array: any) {
  if (Array.isArray(array) && array.length) {
    return array.reduce((accum, value) => {
      const { email } = value;
      if (!value) {
        return accum;
      }
      return [...accum, { label: email, value: email }];
    }, []);
  }
}

export function reduceForLocations(array: any) {
  if (Array.isArray(array) && array.length) {
    return array.reduce((accum, value) => {
      const { id, locationName, isHeadquarters, isLocationActive } = value;
      if (!value || !isLocationActive) {
        return accum;
      }
      return [
        ...accum,
        {
          label: isHeadquarters ? `${locationName} [HQ]` : locationName,
          value: id,
          isHeadquarters,
          locationName,
        },
      ];
    }, []);
  }
}

export function reduceForAgencyInfo(array: any) {
  if (array && array.length) {
    return array.reduce((accum: any, value: any) => {
      const { agencyName, agencyId } = value;
      if (!value) {
        return accum;
      }
      return [...accum, { label: `${agencyName}`, value: agencyId }];
    }, []);
  }
}

export function getAgencyLabel(
  agency: any,
  nameKey = 'name',
  locationAliasKey = 'locationAlias'
) {
  const label =
    agency[locationAliasKey] && !agency[locationAliasKey].includes('null')
      ? `${agency[nameKey]} - ${agency[locationAliasKey]}`
      : agency[nameKey];

  return label;
}
